import Box from '@mui/material/Box';
import Shimmer from './Shimmer';
import { card } from '../../styles/tl5';

// Skeleton for the offers grid. Mirrors the v5 offer card — validity chip
// opposite the square discount tile, campaign kicker, title, then price
// opposite the View Details action — in the same auto-fill grid, so the
// swap to real offers moves nothing.
const OfferCardShimmer = () => (
  <Box sx={{ ...card, display: 'flex', flexDirection: 'column', gap: '14px', p: '26px', minHeight: 236 }}>
    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '14px' }}>
      <Shimmer width={124} height={30} rounded={999} />
      <Shimmer width={64} height={64} rounded={18} />
    </Box>

    <Box>
      <Shimmer width={86} height={12} rounded={4} sx={{ mb: '10px' }} />
      <Shimmer width="78%" height={20} rounded={6} />
    </Box>

    <Shimmer width="92%" height={14} rounded={4} />

    <Box sx={{ mt: 'auto', pt: '6px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
      <Shimmer width={108} height={26} rounded={6} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <Shimmer width={84} height={16} rounded={4} />
        <Shimmer width={34} height={34} circular />
      </Box>
    </Box>
  </Box>
);

const SpecialsShimmer = ({ count = 6 }) => (
  <Box
    aria-label="Loading offers"
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(min(330px, 100%), 1fr))',
      gap: '20px',
      width: '100%',
    }}
  >
    {Array.from({ length: count }).map((_, i) => <OfferCardShimmer key={i} />)}
  </Box>
);

export default SpecialsShimmer;
